/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import {APP_CONFIG} from '../app.config';
import { LocationType } from "../model/LocationType";

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class LocationTypesService {

  private readonly locationUrl;


  constructor(private http: HttpClient) {
    this.locationUrl = inject(APP_CONFIG).baseUrl + '/api/locationtypes';

  }

    getAll(): Observable<LocationType[]> {
        const url = `${this.locationUrl}/all`;
        return this.http.get(url, httpOptions).pipe(
            map(locType => locType as LocationType[]));
    }

    getLocationType(id: any): Observable<LocationType> {
        const url = `${this.locationUrl}/${id}`;
        return this.http.get(url, httpOptions).pipe(
            map(locType => locType as LocationType));
    }

    addNew(newLocationType: LocationType): Observable<LocationType> {
        return this.http.post(this.locationUrl, newLocationType, httpOptions).pipe(
            map(newLocationType => newLocationType as LocationType));
    }

    updateLocationTypes(locationType: LocationType): Observable<LocationType> {
        var url = `${this.locationUrl}/${locationType.locationTypeId}`;
        return this.http.put(url, locationType, httpOptions).pipe(
            map(locationType => locationType as LocationType));
    }
}
